export const COBRANZA_ONLY_USER_ID = '67b32e602d2cea001c2159ff';

export const COBRANZA_ONLY_COMPANY_IDS = [
  '672e53da29b7e2001d8f313c',
  '5ed465daf8e0ab00455991ab',
];

export const COBRANZA_ONLY_ROUTE = '/cobranza';

export const COBRANZA_ONLY_ALLOWED_ROUTES = ['/cobranza', '/agenda'];

export function isCobranzaOnlyUser(userId) {
  return String(userId || '') === COBRANZA_ONLY_USER_ID;
}

export function isCobranzaOnlyCompany(companyId) {
  return COBRANZA_ONLY_COMPANY_IDS.includes(String(companyId || ''));
}

export function isCobranzaOnlyRestrictedContext(userId, companyId) {
  return isCobranzaOnlyUser(userId) && isCobranzaOnlyCompany(companyId);
}

export function canCobranzaOnlyUserAccessRoute(userId, companyId, route) {
  if (!isCobranzaOnlyRestrictedContext(userId, companyId)) return true;
  const normalized = route?.split('?')[0]?.split('#')[0] || '';
  return COBRANZA_ONLY_ALLOWED_ROUTES.includes(normalized);
}
